/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isReady", "placeholderAspectRatio", "loadingBackground", "children"];
import styled from 'foundations-theming/utils';

/* @bend-expect trellis-tokenized */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPadding = styled.div.withConfig({
  displayName: "Wrapper__StyledPadding",
  componentId: "sc-1hul8fh-0"
})(["position:relative;width:100%;padding-top:", ";background-color:", ";"], ({
  isReady,
  placeholderAspectRatio
}) => isReady ? '0' : `${(100 / placeholderAspectRatio).toFixed(2)}%`, ({
  loadingBackground
}) => loadingBackground || '');

/* @bend-expect trellis-tokenized */
const StyledContainer = styled.div.withConfig({
  displayName: "Wrapper__StyledContainer",
  componentId: "sc-1hul8fh-1"
})(["position:", ";top:0;height:100%;width:100%;"], ({
  isReady
}) => isReady ? 'relative' : 'absolute');
export default function Wrapper(_ref) {
  let {
      isReady,
      placeholderAspectRatio,
      loadingBackground,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(StyledPadding, Object.assign({
      isReady: isReady,
      placeholderAspectRatio: placeholderAspectRatio,
      loadingBackground: loadingBackground
    }, restProps, {
      children: /*#__PURE__*/_jsx(StyledContainer, {
        isReady: isReady,
        children: children
      })
    }))
  );
}